import { render, staticRenderFns } from "./huazhuan-apply.vue?vue&type=template&id=b5f17c02&scoped=true&"
import script from "./huazhuan-apply.vue?vue&type=script&lang=js&"
export * from "./huazhuan-apply.vue?vue&type=script&lang=js&"
import style0 from "./huazhuan-apply.vue?vue&type=style&index=0&id=b5f17c02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5f17c02",
  null
  
)

export default component.exports